import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	Typography,
	Stack,
	TextField,
	Box,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "../../../css/empresa_uno/ventas.css";
import buscar_azul from "../../../images/search_azul.png";
import GenerateNotaTraslado from "./../../../Reports/GenerateNotaTraslado";
import { ApiService } from "../../ApiService";
import { useParams } from "react-router-dom";
import { pdf as PDF } from "@react-pdf/renderer";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import { IconButton } from "@mui/material";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from "../../../svg/lupaIcon";
import pdfIcon from "../../../images/pdf.png";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";
import TablesMobile from "../../empresa/TablesMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

export const VnotaTraslado = ({ selectedSucursal }) => {
	const { nit, sub_direc } = useParams();
	const [sucursales, setSucursales] = useState([]);
	const [objNoteCash, setObjNoteCash] = useState([]);
	const [fechaIni, setFechaIni] = useState(null);
	const [fechaFin, setFechaFin] = useState(null);
	const [loadingRows, setLoadingRows] = useState({});
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const getNotaTraslado = async (key_branch, fecha1, fecha2) => {
		const url = `api/company/product/transfer/notes?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
		const options = { method: "GET" };

		const request_totals = await ApiService.fetchData(url, options);

		if (!request_totals) {
			alert("Error al cargar los datos de ventas del día");
			return;
		}

		setObjNoteCash(request_totals);
	};


	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		if (fechaIni == null && fechaFin == null) {
			setFechaFin(currentDate);
			setFechaIni(currentDate);
		}

		setSucursales(current_suc);
		getNotaTraslado(current_suc, fechaIni || currentDate, fechaFin || currentDate);
	}, [selectedSucursal]);

	const handleChange = (e, comp) => {
		comp === 1 ? setFechaIni(e) : setFechaFin(e);
		getNotaTraslado(sucursales, comp === 1 ? e : fechaIni, comp === 2 ? e : fechaFin);
	};
	const generatePdfNotaTraslado = async (nota) => {
		const notaTraslado = nota?.key_transfer??'';
		setLoadingRows((prev) => ({
			...prev,
			[notaTraslado]: true,
		}));

		const url = `api/company/product/transfer/find/${notaTraslado}?key_branch=${selectedSucursal}`;
		const options = { method: "GET" };
		const response = await ApiService.fetchData(url, options);

		if (response !== null) {
			const myDoc = <GenerateNotaTraslado notaTraslado={response} themeColor={'var(--theme-company)'} />;
			const asPdf = PDF(myDoc);
			const blob = await asPdf.toBlob();
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = fileURL;
			link.download = "NotaTraslado.pdf";
			link.click();
			URL.revokeObjectURL(fileURL);
		}

		// Clear loading state only for this row
		setLoadingRows((prev) => ({
			...prev,
			[notaTraslado]: false,
		}));
	}; // Datos estáticos de la tabla
	const totalGeneral =
		objNoteCash &&
		objNoteCash.reduce(
			(acc, note) => (parseFloat(acc) + parseFloat((note.type === 0 ? "-" : "") + note.total)).toFixed(2),
			0
		);

	const componentViewPDF = (nota) => {
		return (
			<button
				className="btn-view"
				style={{
					textDecoration: "none",
					color: "#fff",
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "5px 8px",
					backgroundColor: "var(--theme-company)",
					border: "none",
					borderRadius: "50%",
					cursor: "pointer",
				}}
				onClick={() => generatePdfNotaTraslado(nota)}>
				<FontAwesomeIcon icon={faEye} style={{ color: "#fff", fontSize: "15px" }} />
			</button>
		)
	}

	const returnTotal = () => {
		return totalGeneral;
	}

	return (
		<div>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Nota de Traslado</h2>
					
					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<TextField
							label="Fecha Inicial"
							type="date"
							value={fechaIni}
							onChange={(e) => handleChange(e.target.value, 1)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<TextField
							label="Fecha Fin"
							type="date"
							value={fechaFin}
							onChange={(e) => handleChange(e.target.value, 2)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="Traslados" />

						<div style={{ display: 'none' }}>
							<button className="btn-add-var">
								<img className="icon-down pdf-icon" src={pdfIcon} alt="pdf" />
								<span className="txt-add">PDF</span>
							</button>
						</div>
					</div>
				</div>
			</div>

			{
				currentSize > 480 ? (
					<div className="table-view-pc">
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										{["Fecha", "N.- Nota", "Destino", "Cel. de Adm", "Total", "Ver"].map((header, index) => (
											<TableCell key={index} sx={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
												{header}
											</TableCell>
										))}
									</TableRow>
								</TableHead>

								<TableBody>
									{objNoteCash &&
										objNoteCash.map((note, idx) => (
											<TableRow key={idx}>
												<TableCell align="center">{note.date_transfer}</TableCell>
												<TableCell align="center">{note.nro}</TableCell>
												<TableCell align="center">{note.suc_transfer}</TableCell>
												<TableCell align="center">
													<Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
														<Typography>{note.phone}</Typography>
														<a
															href={`https://wa.me/${note.code_phone + "" + note.phone}`}
															target="_blank"
															rel="noopener noreferrer"
															style={{
																backgroundColor: "#25D366",
																borderRadius: "50%",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																width: "24px",
																height: "24px",
																textDecoration: "none",
															}}>
															<WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
														</a>
													</Stack>
												</TableCell>
												<TableCell align="center">{(note.type === 0 ? "-" : "") + note.total}</TableCell>
												<TableCell
													align="center"
													sx={{
														verticalAlign: "middle",
													}}>
													<Tooltip title="Ver Nota de Traslado">
														<IconButton
															loading={loadingRows[note.key_transfer] || false}
															onClick={() => generatePdfNotaTraslado(note)}>
															<RemoveRedEyeRoundedIcon sx={{ color: "#0468fb" }} />
														</IconButton>
													</Tooltip>
												</TableCell>
											</TableRow>
										))}
								</TableBody>

								<TableFooter>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										<TableCell colSpan={3} align="center" sx={{ color: "white", fontWeight: "bold" }}>
											Total
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{totalGeneral}
										</TableCell>
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
									</TableRow>
								</TableFooter>
							</Table>
						</TableContainer>
					</div>
				) : (
					<TablesMobile filteredData={(objNoteCash ?? []).map(obj => ({
						img: obj?.img_product,
						title: obj?.suc_transfer,
						texto: 'BS. ' + parseFloat(obj?.total).toFixed(2),
						other: obj?.date_transfer,
						fullPhone: obj?.code_phone + obj?.phone,
						authCode: obj?.key_transfer,
						code: obj?.codigo,
					}))} profile={false} mode="reportes" functionEspecial={componentViewPDF} facturado={null} returnTotal={returnTotal} />
				)
			}

		</div>
	);
};
